export const getSeasonsFrom = (startYear: number, endYear?: number) => {
  const currentYear = endYear || new Date().getFullYear();
  return Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => currentYear - i
  );
};
